import { exportGetAutoLoansByCriteria, Filter, getAutoLoansByCriteria } from '@nemuru-eng/js-api-client';

import { exportXLSX } from '@/utils/exportXLSX';
import { fetchForDataGrid } from '@/utils/fetchForDataGrid';

interface UseFetchAutoLoanListProps {
  additionalFilters?: Filter[];
}

export function useFetchAutoLoanList({ additionalFilters }: UseFetchAutoLoanListProps) {
  const queryAdditionalFilters = additionalFilters ?? [];
  const baseQueryFilters = queryAdditionalFilters;

  const fetchAutoLoanList = async (query) => {
    const customFilters = baseQueryFilters.concat(query?.filters);
    const dataTransform = (result) => ({ ...result, data: result.data });
    return fetchForDataGrid(getAutoLoansByCriteria, { ...query, filters: customFilters }, dataTransform);
  };

  const fetchXLSXExport = (query) => {
    const customFilters = baseQueryFilters.concat(query?.filters);
    return exportXLSX(exportGetAutoLoansByCriteria, { ...query, filters: customFilters });
  };

  return { fetchAutoLoanList, fetchXLSXExport };
}
